import styled from 'styled-components';

export const StyledFrequenciesBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 10px;

  @media(max-width: ${props => props.theme.breakpoints.mobile}) {
    display: block;
  }
`;

export const StyledFrequencyOption = styled.div`
  text-align: center;
  width: 32%;
  display: flex;

  .selectable {
    width: 100%;
  }

  .title {
    font-weight: 500;
    line-height: 1.2;
    font-size: ${props => props.theme.fontSizes.small};
  }

  &.current {
    .title {
      color: ${props => props.theme.colors.primary};
    }
  }

  @media(max-width: ${props => props.theme.breakpoints.mobile}) {
    width: 100%;

    & + & {
      margin-top: 10px;
    }
  }
`

export const StyledIcon = styled.div`
  height: 50px;
  text-align: center;
  margin: 0 0 15px;

  img {
    height: 100%;
  }
`

export const StyledPopular = styled.img`
  position: absolute;
  top: -1px;
  left: -1px;
  height: 55px;
`
